import {useFormContext} from '@yandex-delivery/form'
import {get, pipe, toDefaultEmptyString} from '@yandex-delivery/utils'
import {useMemo} from 'react'

import {NDD_PACKAGE_SIZES} from 'src/shared/consts'
import type {Order} from 'src/shared/types'

import {getParcelHeight, getParcelLength, getParcelWeight, getParcelWidth} from './utils'

export function useParcelPhysicalDimensions() {
  const {watch} = useFormContext<Order>()
  const parcels = watch('destinationPoints.0.parcels')

  // Посылки - ссылочно стабильный объект, поэтому можно использовать JSON.stringify, чтобы сравнивать ссылки в useMemo
  const parcelsHash = JSON.stringify(parcels)

  return useMemo(() => {
    let totalSize = 0
    const places = parcels.map(parcel => {
      const length = getParcelLength(NDD_PACKAGE_SIZES, parcel.dimensions, parcel.size)
      const height = getParcelHeight(NDD_PACKAGE_SIZES, parcel.dimensions, parcel.size)
      const width = getParcelWidth(NDD_PACKAGE_SIZES, parcel.dimensions, parcel.size)
      const weight = getParcelWeight(NDD_PACKAGE_SIZES, parcel.dimensions, parcel.size)

      totalSize += length + height + width + weight

      return {
        barcode: pipe(parcel, get('barcode'), toDefaultEmptyString),
        physical_dims: {
          weight_gross: weight,
          dx: length,
          dy: height,
          dz: width,
        },
      }
    })

    return {
      places,
      totalSize,
    } as const
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parcelsHash])
}
